// Homepage.js
import React from 'react'
import { Link } from 'react-router-dom'

function Homepage() {
  return (
    <div
      style={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        background:
          'linear-gradient(135deg, rgba(0,0,0,0.7), rgba(0,0,0,0.4)), url("https://via.placeholder.com/1600x900")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div
        style={{
          textAlign: 'center',
          maxWidth: '600px',
          padding: '2rem',
          borderRadius: '8px',
          backgroundColor: 'rgba(255,255,255,0.8)'
        }}
      >
        <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>
          Welcome to R2D2+
        </h1>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem', lineHeight: 1.5 }}>
          We help companies streamline driver registration at logistics sites
          and customer facilities. Join us today and transform your operations.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          <Link
            to="/app/login"
            style={{
              padding: '0.75rem 1.5rem',
              fontSize: '1rem',
              textDecoration: 'none',
              color: '#fff',
              backgroundColor: '#3b82f6',
              borderRadius: '4px'
            }}
          >
            Log In
          </Link>
          <Link
            to="/app/register"
            style={{
              padding: '0.75rem 1.5rem',
              fontSize: '1rem',
              textDecoration: 'none',
              color: '#fff',
              backgroundColor: '#f97316',
              borderRadius: '4px'
            }}
          >
            Register
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Homepage